import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { version } from '../../../../package.json';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-version-chip',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div *ngIf="!environment.production" class="version-chip">
      v{{version}}
    </div>
  `,
  styles: [`
    .version-chip {
      background-color: #374151;
      color: white;
      padding: 0.25rem 0.75rem;
      border-radius: 9999px;
      font-size: 0.75rem;
      font-weight: 500;
      width: fit-content;
      margin: 0.5rem auto;
    }
  `]
})
export class VersionChipComponent {
  version = version;
  environment = environment;
} 